import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";

export const ManoObraDialog = ({ moDialog, setMoDialog, onGuardar }) => (
  <Dialog open={!!moDialog} onOpenChange={() => setMoDialog(null)}>
    <DialogContent className="bg-white">
      <DialogHeader><DialogTitle>{moDialog?.id ? "Editar mano de obra" : "Agregar mano de obra"}</DialogTitle></DialogHeader>
      <div className="space-y-3">
        <div className="space-y-1"><Label>Descripción del trabajo</Label>
          <Input data-testid="mo-descripcion-input" value={moDialog?.descripcion || ""}
            onChange={(e) => setMoDialog({ ...moDialog, descripcion: e.target.value })} /></div>
        <div className="space-y-1"><Label>Monto (₡)</Label>
          <Input data-testid="mo-monto-input" type="number" min="0" step="any" value={moDialog?.monto ?? ""}
            onChange={(e) => setMoDialog({ ...moDialog, monto: e.target.value })} /></div>
      </div>
      <DialogFooter>
        <Button variant="outline" onClick={() => setMoDialog(null)}>Cancelar</Button>
        <Button data-testid="guardar-mo-btn" onClick={onGuardar} disabled={!moDialog?.descripcion}>Guardar</Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
